export class BndesFilter {
    title: string = '';
    startDate: string = '';
    endDate: string = '';
}
